import * as React from "react";


import LancamentoDiarioDiarioPage from "./detalhe";
import LancamentoDiarioBottom from "./bottom";

export const LancamentoProducaoPage = () => {
  return (
    <React.Fragment>
      <LancamentoDiarioDiarioPage />
      <LancamentoDiarioBottom />
    </React.Fragment>
  );
};
